import create from "zustand";

const statusPassword = create((set) => ({
    openStatus: false,
    setOpenStatus: (state) => set(status => ({ openStatus: state })),
}));
export { statusPassword };